<template>
  <v-container fluid style="height: 100%; padding-bottom: 125px">
    <vehiclesAT v-if="showVehiclesAT"></vehiclesAT>
    <templatesAT v-else></templatesAT>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
export default {
  name: "settingsAT",
  components: {
    vehiclesAT: () => import("@/components/vehiclesAT"),
    templatesAT: () => import("@/components/templatesAT"),
  },
  data: () => ({
    showComponent: false
  }),
  created() {
    this.$store.commit("setTitle", "ALERTRUCK");
    var checking = localStorage.getItem("showVehiclesAT") == undefined || localStorage.getItem("showVehiclesAT") == null
      ? true
      : localStorage.getItem("showVehiclesAT");

    if (checking == "true") checking = true;
    if (checking == "false") checking = false;

    this.$store.commit("showVehiclesAT", checking);
  },
  mounted() {},
  computed: {
    ...mapState([
      "colorTheme",
      "showVehiclesAT"
    ]),
  },
  methods: {}
};
</script>

<style></style>